import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  q: '¿El Kit es digital?',
  a: 'Sí. Recibís los 4 materiales del kit más los 2 materiales premium en formato PDF.'
}, {
  q: '¿Cómo recibo los materiales?',
  a: 'Inmediatamente después de realizar la compra.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Podés acceder desde celular, tablet o computadora.'
}, {
  q: '¿Necesito saber mindfulness?',
  a: 'No. Los ejercicios están explicados para poder aplicarlos directamente.'
}, {
  q: '¿Tengo que hacer los materiales en orden?',
  a: 'No. Podés utilizar directamente la herramienta que necesites según la situación.'
}, {
  q: '¿Sirve solamente para oficinas?',
  a: 'No. Las herramientas fueron pensadas para situaciones laborales de diferentes ámbitos.'
}, {
  q: '¿Puedo imprimirlo?',
  a: 'Sí. Podés utilizarlo digitalmente o imprimir las páginas que quieras tener a mano.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'Acceso de por vida.'
}, {
  q: '¿Tiene garantía?',
  a: 'Sí. Tenés 7 días.'
}];
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-16" data-mp="25hniuzyttt3t">
      <div className="max-w-3xl mx-auto" data-id="element-17" data-mp="20o2m1b8yz567">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-18" data-mp="20n1br8zs2mpj">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-19" data-mp="2jgnamghmyo47">
            Preguntas{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-20" data-mp="p1ce37j5auy0">
              frecuentes
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-21" data-mp="2p5ety88vddnw">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={i} className="bg-white border border-line rounded-2xl overflow-hidden shadow-sm" data-id="element-22" data-mp="2z1ro178bttj6" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left p-5" data-id="element-23" data-mp="3344uxyyt7xhj">
                  <span className="font-semibold text-ink text-sm md:text-base" data-id="element-24" data-mp="3cz6gylxsgjfw">
                    {f.q}
                  </span>
                  <PlusIcon className={`w-5 h-5 text-rose flex-shrink-0 transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-25" data-mp="3mruejiwlerfo" />
                </button>
                {isOpen && <div className="px-5 pb-5 -mt-1 text-ink-soft text-sm md:text-base leading-relaxed" data-id="element-26" data-mp="3vt267i4lsu0s">
                    {f.a}
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}